<script setup>
import {defineProps} from "vue";

const props = defineProps({
    content: Object
});

</script>
<template>
    <div
        class="flex min-h-max min-w-full flex-col items-center space-y-2 bg-gray-300 px-24 py-12 md:min-w-max md:justify-center md:rounded-lg md:shadow-xl md:drop-shadow-md">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
             class="h-8 w-8 stroke-gray-500">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"/>
        </svg>
        <span class="text-lg font-medium">{{ props.content.name }}</span>
        <a :href="props.content.value" class="flex items-center space-x-3 rounded-md border border-gray-400 px-4 py-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                 stroke="currentColor" class="h-4 w-4">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
            </svg>
            <span class="font-light">{{ $tt('content_page__header_download_button') }}</span>
        </a>
    </div>
</template>


